import { t } from "i18next";

import React from "react";

import { FireIcon } from "@components/OrderTaking/Components/Icons/FireIcon";
import { useKcalSetting } from "@components/OrderTaking/common/useKcalSetting";

import "./ComposedProductTotalKcal.css";

type ComposedProductTotalKcalProps = {
    kcal: number | null | undefined;
};

// Footer line of a composed-product card: "🔥 Total avec suppléments : 685 kcal".
// Unlike KcalBadge it is not a coloured pill — it's a flat label + bold value,
// matching the cart design. Self-gates on the global calorie setting and a
// positive value, mirroring ProductCalorie.
export function ComposedProductTotalKcal({
    kcal,
}: ComposedProductTotalKcalProps): JSX.Element | null {
    const { isCalorieActive, customIcon } = useKcalSetting();

    const value = Number(kcal);
    if (!isCalorieActive || !Number.isFinite(value) || value <= 0) return null;

    return (
        <div className="composed-product-total-kcal">
            <span aria-hidden className="composed-product-total-kcal__icon">
                {customIcon ? (
                    <img src={customIcon} alt="" />
                ) : (
                    <FireIcon
                        color="var(--kcal-flame)"
                        width="100%"
                        height="100%"
                    />
                )}
            </span>
            <span className="composed-product-total-kcal__label">
                {t("Total of this item")} :
            </span>
            <span className="composed-product-total-kcal__value">
                {`${Math.round(value)} ${t("kcal")}`}
            </span>
        </div>
    );
}
